import { rootApi } from '@components/rootApi';

const pathWithBaseUrl = (path: string) => `/api/users/${path}`;

const usersApi = rootApi.injectEndpoints({
  endpoints: builder => ({
    impersonate: builder.mutation<void, number | string>({
      query: id => ({
        url: pathWithBaseUrl(`${id}/impersonate`),
        method: 'PATCH',
      }),
    }),

    endImpersonation: builder.mutation<void, void>({
      query: () => ({
        url: pathWithBaseUrl('take_back'),
        method: 'PATCH',
      }),
    }),

    resetPassword: builder.mutation<void, number | string>({
      query: id => ({
        url: pathWithBaseUrl(`${id}/reset_password`),
        method: 'PATCH',
      }),
    }),
  }),
});

export const {
  useImpersonateMutation,
  useEndImpersonationMutation,
  useResetPasswordMutation,
} = usersApi;
